import React, { useRef, useState } from 'react';
import { X, Upload, Download } from 'lucide-react';
import { useQuiz } from '../context/QuizContext';
import { t } from '../i18n';
import { importFromCSV, importFromDOCX, importFromTXT, CSV_TEMPLATE } from '../utils/importers';
import { saveAs } from 'file-saver';

const ImportModal = ({ onClose }) => {
  const { importQuestions, lang } = useQuiz();
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const fileRef = useRef();

  const handleFile = async (file) => {
    if (!file) return;
    setBusy(true); setMsg('');
    try {
      const ext = file.name.split('.').pop().toLowerCase();
      let qs = [];
      if (ext === 'csv') qs = await importFromCSV(file);
      else if (ext === 'docx') qs = await importFromDOCX(file);
      else if (ext === 'txt') qs = await importFromTXT(file);
      else throw new Error(lang === 'id' ? 'Format tidak didukung. Gunakan CSV/DOCX/TXT.' : 'Unsupported format. Use CSV/DOCX/TXT.');
      if (!qs.length) throw new Error(lang === 'id' ? 'Tidak ada soal terdeteksi.' : 'No questions detected.');
      importQuestions(qs);
      setMsg((lang === 'id' ? 'Berhasil impor ' : 'Imported ') + qs.length + (lang === 'id' ? ' soal.' : ' questions.'));
      setTimeout(() => onClose(), 800);
    } catch (e) {
      setMsg('Error: ' + e.message);
    } finally {
      setBusy(false);
    }
  };

  const downloadTemplate = () => {
    const blob = new Blob([CSV_TEMPLATE], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, 'moodle-quiz-template.csv');
  };

  return (
    <div className="mg-modal-overlay" onClick={onClose}>
      <div className="mg-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 640 }}>
        <div className="mg-modal-head">
          <div className="mg-title" style={{ fontSize: 18 }}>{t('importTitle', lang)}</div>
          <button className="mg-close-x" style={{ position: 'static' }} onClick={onClose}><X size={16} /></button>
        </div>
        <div className="mg-modal-body">
          <div className="mg-hint" style={{ marginBottom: 8 }}>• {t('importCsvHint', lang)}</div>
          <div className="mg-hint" style={{ marginBottom: 14 }}>• {t('importDocxHint', lang)}</div>

          <input ref={fileRef} type="file" accept=".csv,.docx,.txt" style={{ display: 'none' }}
                 onChange={e => handleFile(e.target.files[0])} />

          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <button className="mg-btn" style={{ width: 'auto', padding: '10px 16px' }} disabled={busy} onClick={() => fileRef.current.click()}>
              <Upload size={16} /> {t('selectFile', lang)}
            </button>
            <button className="mg-btn ghost" style={{ width: 'auto', padding: '10px 16px' }} onClick={downloadTemplate}>
              <Download size={16} /> {t('downloadTemplate', lang)}
            </button>
          </div>

          {msg && <div style={{ marginTop: 12, color: msg.startsWith('Error') ? '#c9302c' : '#059669' }}>{msg}</div>}
        </div>
        <div className="mg-modal-foot">
          <button className="mg-btn ghost" style={{ width: 'auto', padding: '8px 14px' }} onClick={onClose}>{t('close', lang)}</button>
        </div>
      </div>
    </div>
  );
};

export default ImportModal;
